import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class JhiMetricsService {

    constructor(private http: HttpClient) { }

    getMetrics(): Observable<any> {
        return this.http.get('management/metrics').map((res: HttpResponse<any>) => res);
    }

    threadDump(): Observable<any> {
        return this.http.get('management/dump').map((res: HttpResponse<any>) => res);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/metrics/metrics.service.ts